/* eslint-disable no-restricted-syntax */
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "utils/toast";
import { useAppDispatch } from "store/hooks";
import {
  handleUpdateDealerCareDetailsRequest,
  handleUpdateDealerRequest,
} from "store/modules/DealerCare/thunk.store";
import {
  DealerSearchByIdResponse,
  UpdateDealerRequestProps,
} from "store/modules/DealerCare/types.store";
import { removeCaracterPhone } from "utils/formatByText";

export interface DealerInfoProps {
  dealerTradeName: string;
  dealerEnabled: boolean;
  dealerId: string;
  dealerData: DealerSearchByIdResponse;
}

interface DealerInfoFormProps {
  tradeName: string;
  phone: string;
}

export const useDealerInfo = (data: DealerInfoProps) => {
  const dispatch = useAppDispatch();

  const [editMode, setEditMode] = useState(false);
  const [isReload, setIsReload] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<DealerInfoFormProps>();

  const handleChangeEditMode = () => {
    setEditMode((state) => !state);
    setIsReload(true);
  };

  const handleSubmitData = useCallback(
    async (params: DealerInfoFormProps) => {
      const methodsPayments = () => {
        const methods = data?.dealerData?.paymentMethods.find(
          (methodsValues) => methodsValues?.order === 1,
        );

        return {
          id: methods?.id ?? "",
          order: methods?.order ?? 1,
          description: methods?.description ?? "",
          methods: methods?.methods ?? [],
        };
      };

      const dataUpdate: UpdateDealerRequestProps = {
        dealerId: data.dealerId,
        tradeName: data?.dealerData?.dealerInfo?.tradeName || "",
        methodsPayments: [methodsPayments()],
      };

      const updateDealerCare = {
        dealerId: data?.dealerId,
        tradeName: data?.dealerData?.dealerInfo?.tradeName,
        telephone: {
          number: data?.dealerData?.dealerInfo?.telephone?.number,
          areaCode: data?.dealerData?.dealerInfo?.telephone?.areaCode,
          countryCode: data?.dealerData?.dealerInfo?.telephone?.countryCode,
        },
        cellphone: {
          number: data?.dealerData?.dealerInfo?.cellphone?.number,
          areaCode: data?.dealerData?.dealerInfo?.cellphone?.areaCode,
          countryCode: data.dealerData?.dealerInfo?.cellphone?.countryCode,
        },
        unit: data?.dealerData?.dealerInfo?.unit,
        subunit: data?.dealerData?.dealerInfo?.subunit,
        whatsAppNumber:
          removeCaracterPhone(params?.phone).length <= 11 &&
          removeCaracterPhone(params?.phone).length >= 10
            ? removeCaracterPhone(params?.phone)
            : params?.phone || "",
      };

      if (
        removeCaracterPhone(params?.phone).length > 3 ||
        removeCaracterPhone(params?.phone).length === 0
      ) {
        await dispatch(
          handleUpdateDealerCareDetailsRequest(updateDealerCare),
        ).unwrap();

        await dispatch(handleUpdateDealerRequest(dataUpdate)).unwrap();

        handleChangeEditMode();
      } else {
        toast("Campo telefone não pode ser menor que 4 dígitos", {
          type: "error",
          autoClose: false,
        });
      }
    },
    [
      data.dealerId,
      data.dealerData?.dealerInfo?.tradeName,
      data.dealerData?.dealerInfo?.telephone?.number,
      data.dealerData?.dealerInfo?.telephone?.areaCode,
      data.dealerData?.dealerInfo?.telephone?.countryCode,
      data.dealerData?.dealerInfo?.cellphone?.number,
      data.dealerData?.dealerInfo?.cellphone?.areaCode,
      data.dealerData?.dealerInfo?.cellphone?.countryCode,
      data.dealerData?.dealerInfo?.unit,
      data.dealerData?.dealerInfo?.subunit,
      data.dealerData?.paymentMethods,
      dispatch,
    ],
  );

  return {
    errors,
    setValue,
    register,
    handleSubmitData,
    handleSubmit,
    handleChangeEditMode,
    editMode,
    isReload,
    setIsReload,
  };
};
